import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { auth } from 'apis';
import { useDispatch, useSelector } from 'react-redux';
import { HANDLE_ROLE_SELECTION, SET_ROLES } from 'store/actions';
import { useMe } from 'hooks/useMe';

const SwitchRoleSection = () => {
    const [urpfs, setUrpfs] = useState([]);
    const [currentRole, setCurrentRole] = useState(null);
    const dispatch = useDispatch();
    const { openRoleSelection } = useSelector((state) => state.role);
    const { token } = useSelector((state) => state.auth);
    const { whoami } = useMe();

    const getFunctions = async () => {
        try {
            const res = await auth.getFunctions();
            setUrpfs(res?.data?.urpfIds);
            setCurrentRole(res?.data?.urpfIds?.filter((ur) => ur.selected)?.[0]);
            dispatch({ type: SET_ROLES, roles: res?.data?.urpfIds });
        } catch (e) {
            console.log('SwitchrRoleError', e);
        }
    };

    useEffect(() => {
        getFunctions();
    }, [openRoleSelection, token]);

    const onOpenModal = () => {
        dispatch({ type: HANDLE_ROLE_SELECTION, open: true });
    };

    if (urpfs?.length > 1)
        return (
            <>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                        backgroundColor: '#f5f5f5',
                        padding: '12px 18px',
                        borderRadius: '10px',
                        boxShadow: '0px 4px 6px rgba(0,0,0,0.1)',
                        minWidth: '250px'
                    }}
                >
                    {/* Current Role Label + Role Text */}
                    <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body2" color="textSecondary">
                            {whoami?.personFunction?.[0]?.orgAbbr ?? 'Current Role:'}
                        </Typography>
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            sx={{
                                transition: 'color 0.3s ease-in-out'
                            }}
                        >
                            {currentRole?.roleName}
                        </Typography>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: '#007AFF',
                                '&:hover': { backgroundColor: '#005FCC' },
                                textTransform: 'none'
                            }}
                            onClick={onOpenModal}
                        >
                            Switch Role
                        </Button>
                    </Box>

                    {/* Button to Open Modal */}
                </Box>
            </>
        );
};

export default SwitchRoleSection;
